export default String.raw`

{% assign whatPrice = translations.Brutto | Downcase -%}

{% if customer.Cart.SubtotalPrices -%}
	{% assign whatPrice = translations.Netto | Downcase -%}
{% endif -%}

{% assign attributesDescription = include.AttributesDescription -%}
{% assign uniqueProductId = include.Id -%}
{% assign productUnit = include.SelectedUnit -%}
{% assign productUnitRatio = include.SelectedUnitRatio -%}
{% assign productBasicUnitRatio = include.BasicUnitRatio -%}

{% if page.PageId == config.DefinedPages.CustomerProfile.Id -%}
	{% assign product = include.Product -%}
	{% assign quantity = include.Quantity -%}
	{% assign canAdd1 = false -%}
	{% assign canAdd2 = false -%}
	{% assign canAdd = false -%}
	{% unless product.Price == null or product.AskForPrice -%}
		{% assign canAdd1 = true -%}
	{% endunless -%}
	{% unless product.Availability.Status == 3 or product.HasAttributes -%}
		{% assign canAdd2 = true -%}
	{% endunless -%}
	{% if canAdd1 and canAdd2 -%}
		{% assign canAdd = true -%}
	{% endif -%}
{% endif -%}

{% assign productName = product.Name | H -%}
{% assign productDesc = product.ShortDescription -%}

{% assign flagsSize = product.Flags | Size -%}

{% assign showVariants = false -%}
{% if product.AttributesList.Clip -%}
    {% assign productVariantsSize = 0 -%}
    {% assign productVariantLevel = 0 -%}
    {% for productAttribute in product.AttributesList.Attributes -%}
        {% assign productAttributeValuesSize = productAttribute.Values | Size -%}
        {% if productAttributeValuesSize > 1 -%}
            {% assign groupingAttribute = false -%}
            {% for productAttributeValue in productAttribute.Values -%}
                {% if productAttribute.Values[0].ValueId != productAttributeValue.ValueId -%}
                    {% assign groupingAttribute = true -%}
                    {% break -%}
                {% endif -%}
            {% endfor -%}
            {% if groupingAttribute -%}
                {% assign productVariantsSize = productVariantsSize | Plus: productAttributeValuesSize -%}
                {% assign productVariantLevel = productVariantLevel | Plus: 1 -%}
            {% endif -%}
        {% endif -%}
    {% endfor -%}
    {% if productVariantLevel < 2 and productVariantsSize < 11 -%}
        {% assign showVariants = true -%}
    {% endif -%}
{% endif -%}

{% assign productWithAttributes = false -%}
{% if product.HasAttributes or product.Type == 1 -%}
    {% assign productWithAttributes = true -%}
{% endif -%}
{% assign isPhantom = false -%}
{% if noProductOnControlledStock == true and product.AttributesList.Clip == true -%}
    {% assign isPhantom = true -%}
{% endif -%}

{% assign isPhantomOrHasAttributes = false -%}
{% if page.PageId != config.DefinedPages.CustomerProfile.Id and productWithAttributes or isPhantom == true -%}
    {% assign isPhantomOrHasAttributes = true -%}
{% endif -%}

<tr class="row wishlist-product-container product-item-js can-add-js {% if canAdd and product.Type != 1 -%} can-add-js {% endif -%} {% if config.B2B == false -%} container-to-delete-js {% endif -%}" {% if config.B2B -%} data-product-id="{{uniqueProductId}}" {% else -%} data-product-id="{{product.Id}}" {% endif -%} data-group-id="{{ product.DefaultGroup }}" data-product-name="{{productName|H}}" data-url="{{ page.BaseHref }}{{ product.Url }}">
    <td class="product-cell id">
        <div class="image">
            {% if product.ImageId == -1 -%}
                <svg width="40" height="40"><use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use></svg>
            {% else -%}
                {{ product | Img:'small' }}
            {% endif -%}
        </div>
        <div class="product-info">
            <a class="product-name product-name-js" href="{{ page.BaseHref }}{{ product.Url | H }}" title="{{ product.Name | H }}">{{ product.Name | H }}</a>
            {% if config.Products.ShowCode -%}
                <div class="product-code product-code-js">
                    {{ product.Code | H }}
                </div>
            {% endif -%}
            
            {% if attributesDescription <> "" -%}
                {% assign attributesDescriptionLength = attributesDescription | Size | Minus: 2 -%}
                {% assign convertedAttributesDescriptionArray = attributesDescription | Slice: 0, attributesDescriptionLength | Split: ';' -%}
                <div class="description">
                    {% for attributeDescription in convertedAttributesDescriptionArray -%}
                        {{ attributeDescription }}
                    {% endfor -%}
                </div>
            {% endif -%}
        </div>
    </td>
    <td>
        {% unless customer.HidePrices -%}
            {% assign noProductOnControlledStock = false -%}
            {% if product.StockLevel.QuantityControl == true and product.StockLevel.Value == 0 -%}
                {% assign noProductOnControlledStock = true -%}
            {% endif -%}

            {% assign productWithAttributes = false -%}
            {% if product.HasAttributes or product.Type == 1 -%}
                {% assign productWithAttributes = true -%}
            {% endif -%}
            
            {% assign isPhantom = false -%}
            {% if noProductOnControlledStock == true and product.AttributesList.Clip == true -%}
                {% assign isPhantom = true -%}
            {% endif -%}

            {% assign notifyAvailability = false -%}
            {% if product.Availability.Status == 3 or noProductOnControlledStock -%}
                {% assign notifyAvailability = true -%}
            {% endif -%}
            {% if product.Price == null or product.AskForPrice -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=askForPrice">
                    {{ translations.AskForPrice }}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                </a>
            {% elseif notifyAvailability and isPhantom == false -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=notifyMe">{{ translations.NotifyMeAboutAvailability }}</a>
            {% elseif productWithAttributes or isPhantom -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}">
                    {{ translations.AvailableProductVariants }}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                    </svg>    
                </a>    
            {% else -%}
                {% include 'partials/product/simple-add-to-cart.html' with product -%}
            {% endif -%}
        {% endunless -%}
    </td>
    <td>
        <div class="price-column">
            {% if settings.thresholds == 'yes' and product.HasThresholds and product.Price != null-%}
                {% assign whatPrice = translations.Brutto | Downcase -%}
                {% if customer.Cart.SubtotalPrices -%}
                    {% assign whatPrice = translations.Netto | Downcase -%}
                {% endif -%}
                {% assign firstThreshold = product.Thresholds | First -%}
                {% assign lastThreshold = product.Thresholds | Last -%}
                <div>
                    <strong>{{ translations.RangeFrom | Downcase }} {{ lastThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</strong>
                </div>
                <div>
                    {{ translations.RangeTo | Downcase }} {{ firstThreshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}
                </div>
                {% assign thresholdsSize = product.Thresholds | Size -%}
                {% if thresholdsSize >= 2 -%}
                    <button class="pure-button open-next-element-js">
                        <span>{{ translations.SeePriceDetails }}</span>
                    </button>
                    <div class="popup-background hidden-js hide-js container-to-hide-js">
                        <div class="popup thresholds-popup">
                            <div class="popup__header">
                                <div class="title">{{ translations.PriceDetails }}</div>
                                <svg class="hide-container-js">
                                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
                                </svg>
                            </div>
                            <div class="popup__content">
                                <div class="name">{{ product.Name }}</div>
                                <div class="thresholds">
                                    <div class="thresholds__row">
                                        <span>{{ translations.Quantity }} [{{ product.SaleUnit }}]:</span>
                                        <span>{{ translations.Price }} {{ whatPrice }}:</span>
                                    </div>
                                    {% for threshold in product.Thresholds -%}
                                        <div class="thresholds__row">
                                            <div>{{ threshold.Threshold | Normalize }}+</div>
                                            <div>{{ threshold.FinalPrice | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }}</div>
                                        </div>
                                    {% endfor %}
                                </div>
                            </div>
                        </div>
                    </div>
                {% endif -%}
            {% else -%}
                {% if product.SaleUnit <> productUnit -%}
                    {% if product.Price != null -%}
                        <span>
                            <span>{{ product.Price | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</span> 
                        </span>
                        {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                            <span style="text-decoration: line-through;">
                                {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
                                    {% if customer.Cart.SubtotalPrices -%}
                                        {{ product.PreviousPrice | Times: 1.23 | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                                    {% else -%}
                                        {{ product.PreviousPrice | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                                    {% endif -%}
                                {% else -%}
                                    {{ product.PreviousPrice | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                                {% endif -%} 
                            </span>
                            {% if settings.lowestProductPrice == 'yes' -%}
                                <div>{{translations.Price_Omnibus}} {{ product.MinPrice | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}</div>
                            {% endif -%}                                            
                        {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                            <span style="text-decoration: line-through;">
                                {{ product.RegularPrice | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                            </span>
                        {% endif -%}
                    {% endif -%}
                {% else  -%}
                    {% if product.Price != null -%}
                        <span>
                            {{ product.Price | ToPrice }} {{ currencyExt }}
                            {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                                <small style="text-decoration: line-through;">
                                    {% if settings.previousPriceAsSuggestedRetailPrice == 'yes' %}
                                        {% if customer.Cart.SubtotalPrices -%}
                                            {{ product.PreviousPrice | Times: 1.23 | Round: config.DecimalPlacesPrice | ToPrice }} {{ currencyExt }}
                                        {% else -%}
                                            {{ product.PreviousPrice | ToPrice }} {{ currencyExt }}
                                        {% endif -%}
                                    {% else -%}
                                        {{ product.PreviousPrice | ToPrice }} {{ currencyExt }}
                                    {% endif -%} 
                                </small>
                            {% elseif product.RegularPrice > product.Price and product.RegularPrice != null and config.ENTERPRISE and settings.lowestProductPrice == 'no' -%}
                                <small style="text-decoration: line-through;">
                                    {{ product.RegularPrice | ToPrice }} {{ currencyExt }}
                                </small>
                            {% endif -%}
                        </span> 
                        {% if product.DepositValue > 0 -%}
                            <small>
                                + {{ translations.Com_Deposit }}: {{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }} {{ currencyExt }} / {{ product.BasicUnit }}
                            </small>
                        {% endif -%}
                        {% if product.PreviousPrice > product.Price and product.PreviousPrice != null -%}
                            {% if settings.lowestProductPrice == 'yes' -%}
                                <small>{{translations.Price_Omnibus}} {{ product.MinPrice | ToPrice }} {{ currencyExt }}</small>
                            {% endif -%}
                        {% endif -%}
                    {% endif -%}
                {% endif -%}
            {% endif -%}
        </div>
    </td>

    <td>
        <span>{% if product.Price != null -%}<span class="total-price-on-list-view-js">{% if product.SaleUnit <> productUnit -%}{{ product.Price | DividedBy: productBasicUnitRatio | Times: productUnitRatio | Round: config.DecimalPlacesPrice | ToPrice }}{% else -%}{{ product.Price | ToPrice }}{% endif -%}</span> {{ currencyExt }}{% endif -%}</span> 
    </td>

    <td>
        {% if product.Price != null and showDeposit -%}
            {% if product.DepositValue > 0 -%}
                <span>
                    <span class="total-deposit-on-list-view-js">{{ product.DepositValue | ToPrice: config.DecimalPlacesPrice }}</span> {{ currencyExt }}
                </span>  
            {% else -%}
                0,00 {{ currencyExt }}
            {% endif -%}  
        {% endif -%}
    </td>

{% if config.B2B == false -%}
    <td>
        {% assign day = '1.00:00:00' | ToTimeSpan -%}
        {% assign minDate = config.Now | Plus:day | Date:'yyyy-MM-dd' -%}
        {% assign savedDate = include.NotifyDate | Date:'yyyy-MM-dd' -%}
        <input aria-label="{{ translations.ReminderDate }}" class="form__input-value update-reminder-date-js" type="date" name="notifyDate" value="{% if savedDate >= minDate -%}{{savedDate}}{% endif -%}" min="{{minDate}}" max="2200-12-31" data-id="{{product.Id}}" style="width: 150px;"/>
    </td>
{% endif -%}    
{% if config.B2B == false -%}
    <td>
        {% unless customer.HidePrices -%}
            {% assign noProductOnControlledStock = false -%}
            {% if product.StockLevel.QuantityControl == true and product.StockLevel.Value == 0 -%}
                {% assign noProductOnControlledStock = true -%}
            {% endif -%}

            {% assign productWithAttributes = false -%}
            {% if product.HasAttributes or product.Type == 1 -%}
                {% assign productWithAttributes = true -%}
            {% endif -%}
            
            {% assign isPhantom = false -%}
            {% if noProductOnControlledStock == true and product.AttributesList.Clip == true -%}
                {% assign isPhantom = true -%}
            {% endif -%}

            {% assign notifyAvailability = false -%}
            {% if product.Availability.Status == 3 or noProductOnControlledStock -%}
                {% assign notifyAvailability = true -%}
            {% endif -%}
            {% if product.Price == null or product.AskForPrice -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=askForPrice">
                    {{ translations.AskForPrice }}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{settings.iconStyle}}"></use>
                    </svg>
                </a>
            {% elseif notifyAvailability and isPhantom == false -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}?open=notifyMe">{{ translations.NotifyMeAboutAvailability }}</a>
            {% elseif productWithAttributes or isPhantom -%}
                <a class="secondary-action-button" href="{{ page.BaseHref }}{{ product.Url | H }}">
                    {{ translations.AvailableProductVariants }}
                    <svg width="20" height="20">
                        <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{settings.iconStyle}}"></use>
                    </svg>    
                </a>    
            {% endif -%}
        {% endunless -%}
    </td>
{% endif -%}
{% if config.B2B -%}
    <td class="options drop">
        <button class="pure-button delete-product-from-wishlist-js" title="{{ translations.Delete }}">
            <svg width="20" height="20">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
            </svg>
        </button>
    </td>
{% else -%}
    <td class="options drop">
        <div class="form-js">
            <input type="hidden" name="__action" value="Product/WishListDelete">
            <input type="hidden" name="productId" value="{{ product.Id }}">
            <button class="pure-button delete-product-from-wishlist-js" title="{{ translations.Delete }}">
                <svg width="20" height="20">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#trash-alt-{{settings.iconStyle}}"></use>
                </svg>
            </button>
        </div>
    </td>
{% endif -%}
</tr>
`